import {createContext, useContext, useReducer} from "react";
import {useStorage} from "../hooks/useStorage";
const UserContext = createContext(null);

export const types = {
    "SET_LOADING": "SET_LOADING",
    "SET_USER_DATA": "SET_USER_DATA",
    "SET_ERRORS": "SET_ERRORS",
}

const initializeState = {
    userData: undefined,
    message:null,
    loading:false,
}

const reducer = (state, action)=>{
    switch (action.type){
        case types.SET_LOADING: state = {...state, loading:true};
            break;
        case types.SET_ERRORS: state = {...state, message:action.message};
            break;
        case types.SET_USER_DATA:state = {...state, userData: action.userData}
            break;

        default : throw Error(`An unknown Action to User Reducer ${action.type}`)
    }
    // console.log(state);
    return state;
}

const UserProvider = ({children})=>{
    let {getUser} = useStorage();
    initializeState.userData = getUser();
    let [state, dispatch] = useReducer(reducer, initializeState, ()=>initializeState);

    return(
        <UserContext.Provider value={{state, dispatch}}>
            {children}
        </UserContext.Provider>
    )
}

const useUser = () => {
    const {clear}  = useStorage();
    let context = useContext(UserContext);
    if (!context){
        throw Error("useUser should be used inside UserProvider");
    }

    const logout = ()=>{
        clear();
        window.location.href = "/"
    }

    let {state, dispatch} = context;
    return{state, dispatch, logout};
}

export {UserProvider, useUser}